















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Dialog, Button } from 'element-ui';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

@Component({
  components: {
    Dialog,
    Button,
  },
})
export default class extends Vue {
    @Prop({ type: Boolean, default: true })
    modalClick: any;


    @Getter public dialogDescribe: any;

    @Mutation public closeDialog;

    @Mutation public openDialog;

    // public dialogDescribe: any = {
    //   visible: true,
    //   titleClose: false,
    //   titleIcon: false,
    //   type: 'needGroupTest',
    //   longText: '',
    //   text: '提示',
    //   footer: [
    //         {
    //             class: 'button-style-border',
    //             word: '复习本组',
    //         },
    //         {
    //             class: 'button-style-background',
    //             word: '测试本组',
    //         },
    //         {
    //             class: 'button-style-home-before',
    //             word: '<',
    //         },
    //         {
    //             class: 'button-style-home button-style-home-three',
    //             word: '回到首页',
    //         },
    //   ],
    // };    

    private close() {
      this.closeDialog();
      this.$emit('closeHandle');
    }

    private created() {
    }

    private buttonClick(index: number, data:any) {
      this.$emit('dialogHandle', index, data);
    }
}
